// https://vuex.vuejs.org/en/actions.html

import productContentService from '@/services/productContentService'
import productService from '@/services/productService'
import store from '@/store'
import i18n from '@/i18n'

export default {
  async RefreshProducts (context) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Product.RefreshProducts'))
    var apiResult = await productService.getOverview()
    if (apiResult.success === false) {
      store.dispatch('RemoveLoadingMessage', loadingId)
      return apiResult
    }

    await SetProductsDetailsBasic(apiResult.value)

    context.commit('refreshProducts', apiResult.value)

    if (store.state.vendors.list.length < 1) {
      store.dispatch('RefreshVendors')
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async GetProductsByVariantUids ({ context }, variantUids) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Product.RefreshProducts'))
    var apiResult = await productService.getByVariant(variantUids)
    if (apiResult.success === false) {
      store.dispatch('RemoveLoadingMessage', loadingId)
      return apiResult
    }

    await SetProductsDetailsBasic(apiResult.value)

    store.commit('updateProducts', apiResult.value)

    if (store.state.vendors.list.length < 1) {
      store.dispatch('RefreshVendors')
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async UpdateProductInfo ({ context }, productUid) {
    let loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Product.RefreshProducts'))
    let apiResult = await productService.getByUid(productUid)
    if (apiResult.success === false) {
      store.dispatch('RemoveLoadingMessage', loadingId)
      return apiResult
    }

    let products = [apiResult.value]
    await SetProductsDetailsBasic(products)

    store.commit('updateProducts', products, true)
    store.dispatch('RemoveLoadingMessage', loadingId)
      return apiResult
  },
  async GetProductDetails ({ commit, state }, productUid) {
    var product = state.list.find(p => {
      return p.uid === productUid
    })
    if (!product) {
      return
    }
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Product.GetProductDetails'))
    var productDetailsApiResult = await productContentService.getDetails(product.contentNodeId)
    if (productDetailsApiResult.success) {
      commit('refreshProductDetails', productDetailsApiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return productDetailsApiResult
  },
}

async function SetProductsDetailsBasic (products) {
    var contentOverviewApiResult = await productContentService.getOverview()
    // combine both basic data
    products.forEach(product => {
      if (contentOverviewApiResult.success) {
        var contentResult = contentOverviewApiResult.value
        var content = contentResult.find(
          contentItem => contentItem.nodeId === product.contentNodeId
        )
        if (content) {
          product.displayName = content.name
          product.vendorDisplayName = content.vendor
        }
      }
      // set computed properties
      product.typeDisplayName = product.type
      product.recurringDisplayName = ''
      if (product.type === 'Flex' || product.type === 'Fixed') {
        var recurringDisplayName = ''
        if (product.recurringIntervalQuantity > 0) {
          recurringDisplayName = ' ' + product.recurringIntervalQuantity + ' ' + product.recurringTimeInterval
          product.typeDisplayName = product.typeDisplayName + ' (' + product.type + recurringDisplayName + ')'
        }
        product.displayNameWithType = product.displayName + ' (' + product.type + recurringDisplayName + ')'
        product.recurringDisplayName = product.type + recurringDisplayName
      } else {
        product.displayNameWithType = product.displayName
      }
    })
  }
